import './NetworkIndicator.scss'
import React, { useEffect, useState } from 'react'
import { ConnectionStatus, Network } from '@capacitor/network'
import { useAppState } from '../functions/appStates'
import { networkStatus } from '../functions/appStates'
import {
  cellularOutline,
  cloudOfflineOutline,
  extensionPuzzleOutline,
  wifiOutline,
} from 'ionicons/icons'
import { IonIcon, useIonAlert } from '@ionic/react'

let timeoutId: NodeJS.Timeout | undefined

const NetworkIndicator: React.FC = () => {
  const [animate, setAnimate] = useState(true)
  const [icon, setIcon] = useState(extensionPuzzleOutline)
  const [label, setLabel] = useState('Unknown')
  const [status, setStatus] = useAppState(networkStatus)
  const [presentAlert] = useIonAlert()

  const onStatusChange = (newStatus: ConnectionStatus) => {
    const status = newStatus.connectionType
    setStatus(status)
    if (status === 'wifi') {
      setIcon(wifiOutline)
      setLabel('WiFi')
    } else if (status === 'cellular') {
      setIcon(cellularOutline)
      setLabel('Cellular')
    } else if (status === 'none') {
      setIcon(cloudOfflineOutline)
      setLabel('Disconnected')
    } else {
      setIcon(extensionPuzzleOutline)
      setLabel('Unknown')
    }
    clearTimeout(timeoutId)
    setAnimate(true)
    timeoutId = setTimeout(() => {
      setAnimate(false)
    }, 5000)
  }

  useEffect(() => {
    Network.getStatus().then((status) => {
      onStatusChange(status)
    })
    Network.addListener('networkStatusChange', (status) => {
      onStatusChange(status)
    })
  }, [])

  //
  const showAlert = () => {
    presentAlert({
      header: 'Network Indicator ',
      subHeader: 'Using WiFi or Cellular networks',
      message:
        'Be aware this app needs to download data from servers.' +
        'It will comsume your mobile data quota if being used with Cellular networks.',
      cssClass: 'network-indicator-alert',
      buttons: [
        {
          text: 'Dismiss',
          role: 'confirm',
          handler: () => {},
        },
      ],
      onDidDismiss: (e: CustomEvent) => {
        let element = document.getElementById('network-indicator-label')
        element?.classList.add('animate')
        setTimeout(() => {
          element?.classList.remove('animate')
        }, 5000)
      },
    })
  }

  return (
    <div className={status + ' indicator'}>
      <div
        className={(animate ? 'animate ' : '') + 'label'}
        id="network-indicator-label"
      >
        <span>{label}</span>
      </div>
      <IonIcon icon={icon} onClick={showAlert} />
    </div>
  )
}
export default NetworkIndicator
